import {useContext, useEffect, useState} from "react";
import {Context} from "./Context";
import {useDropzone} from "react-dropzone";
import FindFileButton from "./IconButton/FindFileButton";
import {SelectTrans} from "./SelectTrans";
import {apiUrl} from "../../component/apiUrl";
import Post from "../../component/Post";
import {Translator, UploadFileType} from "../../component/ForTrans";
import {hide} from "../../component/Functions";

export default function SubmitFile() {
    const {
        file,
        setFile,
        original,
        setOriginal,
        fileType,
        setSubmitVal,
        setFileType,
        setSelectedTranslate,
        selectedTranslate,
        metaData,
        setTranslate,
        modify,
    } = useContext(Context)
    const sST  = setSelectedTranslate

    useEffect(() => {
        if (file) {
            const formData = new FormData()
            formData.append("inputFile", file)
            formData.append("lang", 'en')
            formData.append("testId", 0)
            fetch(apiUrl+'/ftt/' + fileType, {
                // fetch("http://localhost:8080/ftt/ttt", {
                // fetch("http://localhost:8080/ftt/"+fileType, {
                method: "POST",
                body: formData,
            })
                .then(r => r.text())
                .then(r => setOriginal(r))
                .catch(console.error)
        }
    }, [file]);

    const [google, setGoogle] = useState('')
    const [gemini, setGemini] = useState('')
    const [chatGpt, setChatGpt] = useState('')
    const [deepl, setDeepl] = useState('')
    const [memSource, setMemSource] = useState('')
    const [naver, setNaver] = useState('')
    const [systran, setSystran] = useState('')

    useEffect(() => {
        if (modify) return;
        if (original !== "") {
            if (metaData.translator.length === 0) {
                alert('번역기를 선택해주세요.')
                return
            }
            let a = original.split(".").slice(0, 5).join(".")
            if (a.length > 100) a = original.split("\n").slice(0, 5).join("\n")
            if (a.length > 100) a = original.slice(0,100)
            metaData.translator.forEach(it => {
                const to = it.includes(' ') ? it.split(' ')[0] : it
                Post('translate/' + to.toLowerCase(), {
                    source: 'ko',
                    target: 'en',
                    text: a
                })
                    .then(res => res.text())
                    .then(res => {
                        switch (it) {
                            case Translator[0]:
                                setGoogle(res)
                                break;
                            case Translator[1]:
                                setChatGpt(res)
                                break;
                            case Translator[2]:
                                setGemini(res)
                                break;
                            case Translator[3]:
                                setDeepl(res)
                                break;
                            case Translator[4]:
                                setMemSource(res)
                                break;
                            case Translator[5]:
                                setNaver(res)
                                break;
                            case Translator[6]:
                                setSystran(res)
                                break;
                            default:
                        }
                    })
            })
            const textarea = document.getElementById("originalTextArea")
            if (!textarea) {
            } else {
                textarea.style.height = "0px";
                textarea.style.height = textarea.scrollHeight + "px";
            }
        }
    }, [original]);

    const set = (e) => setFileType(e.target.value)

    const onDrop = (acceptedFile) => setFile(acceptedFile[0])

    const {getRootProps, getInputProps, isDragActive, isFileDialogActive}  = useDropzone({onDrop})

    const save = () => {
        Post('translate/' + selectedTranslate.toLowerCase(), {
            source: 'ko',
            target: 'en',
            text: original,
        }).then(res => res.text())
            .then(data=>setTranslate(data))
            .then(_=>{
                hide('submit trans file')
                hide('submit trans edited')
            })
    }

    const chooseValue = (t, index) =>{
        switch (t){
            case Translator[0]: return <SelectTrans key={'wnceoj'+index} fn={()=>sST('google')} value={google} label={t}/>
            case Translator[1]: return <SelectTrans key={'wnceoj'+index} fn={()=>sST('chat-gpt')} value={chatGpt} label={t}/>
            case Translator[2]: return <SelectTrans key={'wnceoj'+index} fn={()=>sST('gemini')} value={gemini} label={t}/>
            case Translator[3]: return <SelectTrans key={'wnceoj'+index} fn={()=>sST('deepl')} value={deepl} label={t}/>
            case Translator[4]: return <SelectTrans key={'wnceoj'+index} fn={()=>sST('memSource')} value={memSource} label={t}/>
            case Translator[5]: return <SelectTrans key={'wnceoj'+index} fn={()=>sST('naver')} value={naver} label={t}/>
            case Translator[6]: return <SelectTrans key={'wnceoj'+index} fn={()=>sST('systran')} value={systran} label={t}/>
            default: return null
        }
    }

    return (<div id={'submit trans file'}>
        <section>
            <table>
                <thead>
                <tr>
                    <th>
                        <select className={"inputBorder inputTextAreaMargin"} onChange={e => set(e)}>
                            {UploadFileType.map((it, index) =>
                                (<option selected={index === 0} disabled={index === 0}
                                         key={it + index.toString()} value={it.key}>{it.value}</option>))}
                        </select>
                    </th>
                </tr>
                </thead>
                <tbody>
                {!file && fileType === UploadFileType[0].key ?
                    <tr>
                        <td>업로드할 파일 형식을 선택해주세요.</td>
                    </tr>
                    : fileType === UploadFileType[4].key ?
                        <tr>
                            <td>
                                <div style={{marginTop: "20px"}} className={'row centerElements'}>
                                    <img src="/images/youtube.svg" alt=""/>
                                    <img src="/images/toward.svg" alt=""/>
                                    <img src="/images/text.svg" alt=""/>
                                </div>
                                <div style={{marginTop: "20px", width: 500}} className={'row center'}>
                                    <input className={"inputBorder inputTextAreaMargin"} placeholder={'업로드할 영상의 링크를 입력해주세요.'}/>
                                    <button className={`blackButton`}>업로드</button>
                                </div>
                            </td>
                        </tr>
                        : <tr>
                            <td id="file" {...getRootProps()}
                                style={isDragActive || isFileDialogActive ? {backgroundColor: "#e5e5e5"} : null}>
                                {fileType === UploadFileType[1].key && <>
                                    <img src="/images/fileIcon.svg" alt="" className={`m-auto mb-8`}/>
                                    <p style={{marginTop: "15px"}}>업로드할 파일을 드래그하세요.</p>
                                </>}
                                <input className={"inputBorder inputTextAreaMargin"} {...getInputProps()}/>
                                <div style={{marginTop: "20px"}} className={'row centerElements'}>
                                    {fileType === UploadFileType[1].key ? <>
                                        <img src="/images/pdf.svg" alt=""/>
                                        <img src="/images/ppt.svg" alt=""/>
                                        <img src="/images/doc.svg" alt=""/>
                                        <img src="/images/txt.svg" alt=""/>
                                    </> : fileType === UploadFileType[2].key ? <>
                                        <img src="/images/sound.svg" alt=""/>
                                        <img src="/images/to.svg" alt=""/>
                                        <img src="/images/text.svg" alt=""/>
                                    </> : fileType === UploadFileType[3].key ? <>
                                        <img src="/images/video.svg" alt=""/>
                                        <img src="/images/toward.svg" alt=""/>
                                        <img src="/images/text.svg" alt=""/>
                                    </> : null
                                    }
                                </div>
                                {fileType !== UploadFileType[1].key ?
                                    <p style={{marginTop: "15px"}}>업로드할 파일을 드래그하세요.</p> :
                                    <FindFileButton/>
                                }
                            </td>
                        </tr>
                }
                </tbody>
            </table>
        </section>
        <section>
            <table>
                <thead>
                <tr>
                    <th width="50%" className={'centers'}>
                        <div className="centerElements">
                            <img src="/images/transOrigin.svg" alt=""/>
                            <span>원문</span>
                        </div>
                    </th>
                    <th width="50%">
                        <div className="centerElements">
                            <img src="/images/transResult.svg" alt=""/>
                            <span>번역된 내용</span>
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr className={`w-full`}>{!file ?
                    <>
                        <td><img src="/images/original.svg" alt=""/><p>업로드 된 파일의 텍스트 표시</p></td>

                        <td><img src="/images/translated.svg" alt=""/><p>번역된 텍스트 표시</p></td>
                    </>
                    : <>
                        <td className={`h-full break-words text-wrap`}>
                            {original === "" ? <>
                                    <img src="https://media.tenor.com/On7kvXhzml4AAAAj/loading-gif.gif" alt=""/>
                                    <span>텍스트 추출 중...</span>
                                </> :
                                <div style={{
                                    width: "100%", height: "100%", padding: 10,
                                    border: "1px solid black", borderRadius: 10,
                                }}>
                                    {typeof original === 'string' && original}
                                </div>}
                        </td>
                        <td className={`h-full break-words text-wrap`}>
                            {metaData.translator.length === 0 ? <>
                                    <img src="https://media.tenor.com/On7kvXhzml4AAAAj/loading-gif.gif" alt=""/>
                                    <span>번역 중...</span>
                                </> :
                                metaData.translator.length === 1 ? chooseValue(metaData.translator[0])
                                    : <div style={{ display: 'grid',
                                        gridTemplateColumns: 'repeat(2, 1fr)',
                                        gridTemplateRows: 'repeat(2, 1fr)',
                                        width: '100%',
                                        height: '100%'}}>{metaData.translator.map(chooseValue)}
                                    </div>}</td></>}
                </tr>
                </tbody>
            </table>
        </section>
        {selectedTranslate !=='' &&
            <button
                className={`w-full !ml-0 text-center bg-slate-950 text-white py-4 mb-8`}
                onClick={() => {
                save()
                setSubmitVal(true)
        }}>AI 번역
        </button>}
    </div>)
}